// extracted by mini-css-extract-plugin
export default {"page":"MGPage_page__-FLs5","mobileViewport":"MGPage_mobileViewport__K2XCI","body":"MGPage_body__eLPZx","content":"MGPage_content__vdMTV"};